module.exports = __webpack_public_path__ + "static/apk/eruul.apk";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=static/apk/[name].[ext]!./src/assets/apk/eruul.apk
// module id = hFpf
// module chunks = 2